import styled from 'styled-components'
//使用实例---关于页面
{
  /* <Trapezium title={'版本信息'} style={{ paddingTop: '24px', paddingBottom: '24px' }} /> */
}
export const Trapezium = props => {
  const { title, style } = props
  return (
    <Title style={style}>
      <div className="title">{title}</div>
    </Title>
  )
}
const Title = styled.div`
  padding: 0 0 0 16px;
  padding-right: 0;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  align-items: center;
  .title {
    color: #333333;
    font-weight: 600;
    position: relative;
    font-size: 16px;
    /**前缀*/
    &::before {
      content: '';
      display: inline-block;
      width: 24px;
      height: 0;
      border-bottom: 6px solid #4238c9;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      transform: translate(0, -50%) rotate(90deg);
      position: absolute;
      top: 50%;
      left: -24px;
    }
  }
`
